/* eslint-disable prettier/prettier */
import { useState, useEffect, useCallback } from 'react';
import { dashboardService } from '../services/dashboardService';
import { UpcomingSession,UpcomingSessionCount } from '../types/dashboard';

export const useUpcomingSessions = (limit: number = 5) => {
	// const [sessions, setSessions] = useState<UpcomingSession[]>([]);
	const [sessions, setSessions] = useState<UpcomingSessionCount[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	const fetchUpcomingSessions = useCallback(async () => {
		setLoading(true);
		setError(null);

		try {
			const data =
				await dashboardService.getUpcomingSessions(limit);

			setSessions(data);
		} catch (err: any) {
			setError(
				err instanceof Error
					? err.message
					: 'Failed to fetch upcoming sessions'
			);
		} finally {
			setLoading(false);
		}
	}, [limit]);

	useEffect(() => {
		fetchUpcomingSessions();
	}, [fetchUpcomingSessions]);

	return {
		sessions,
		loading,
		error,
		refreshUpcomingSessions: fetchUpcomingSessions,
	};
};